import type React from "react";
import {Skeleton, Stack} from "@mui/material";

/** The tree view's shape while the taxonomy loads: the filter row above the canvas, then the canvas. */
export const TaxonomyTreeViewSkeleton: React.FC = () => (
    <Stack gap={2} sx={{flex: 1, minHeight: 0}}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
            <Stack direction="row" alignItems="center" gap={1}>
                <Skeleton variant="rounded" width={330} height={34}/>
                <Skeleton variant="rounded" width={120} height={30}/>
            </Stack>
            <Skeleton variant="rounded" width={90} height={30}/>
        </Stack>
        <Skeleton variant="rounded" sx={{flex: 1, height: 'auto', borderRadius: '12px'}}/>
    </Stack>
);
